import HTTPStatus from '@/constants/httpStatus';
import flagKeys from '@/constants/flagKeys';

import APIService from '../api';

export default class BackendAvailability extends APIService {
  host() {
    return process.env.VUE_APP_SERVICES_URL;
  }

  async getStatus(flags: string[] = []) {
    try {
      if (flags.includes(flagKeys.maintenanceMode)) {
        return {
          available: false
        };
      }

      const { status, data } = await this.get<{
        coreDatabase: boolean;
        isMaintenanceMode: boolean;
      }>('/server-status/status');

      if (status === HTTPStatus.OK) {
        return {
          available: data.coreDatabase && !data.isMaintenanceMode
        };
      }

      return { available: true };
    } catch (err) {
      return { available: true };
    }
  }
}
